export default __webpack_public_path__ + "c79c10df67b567063c312999cfb0e5d4.jpeg";